<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/portugal')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/portugal')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Valle del Douro</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Con così tante variabili nel terroir della Valle del Douro, ci si potrebbe sbagliare nel pensare che la differenza tra un porto e l'altro riguardi la miscelazione. Mentre i capricci del clima e dell'esposizione erano sempre stati rispettati, i portoghesi impiegarono un po' a capire che la prova era nel terreno. A lungo pensato solo come scisto e granito, con la moda emergente per il vino da tavola, i produttori di vino hanno iniziato ad allontanarsi dalla produzione di Porto e ad osservare più da vicino ciò in cui stanno piantando. A causa dei ripidi pendii della regione, le viti che sono state in grado di forzare le loro radici attraverso il granito rotto potrebbero offrire un'opzione molto diversa rispetto a quelle coltivate su terreni più orizzontali.
                        <br><br>
                        Al fine di tentare un buck the trend e cambiare il pensiero del mondo sul buon vino portoghese,
                        cooperative di giovani viticoltori hanno rivisitato il magnifico vino rosso del paese
                        eredità. Queste bellezze corpose sono relativamente poco costose da acquistare sul mercato primario
                        e può recuperare fino a xxxx sul mercato secondario, quindi vale la pena considerare se lo desideri
                        espandi il tuo folio "port".
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Douro-Tal</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Bei so vielen Variablen im Terroir des Douro-Tals würde man sich irren, wenn man annimmt, dass der Unterschied zwischen den einzelnen Portweinen in der Mischung liegt. Während die Unwägbarkeiten des Klimas und der Lage stets berücksichtigt wurden, dauerte es eine Weile, bis die Portugiesen erkannten, dass der Beweis im Boden lag. Lange dachte man, dass es sich nur um Schiefer und Granit handelte, aber mit der aufkommenden Mode für Tafelwein begannen die Winzer, sich von der Portweinproduktion zu entfernen und genauer darauf zu achten, was sie anbauen. Aufgrund der steilen Hänge der Region könnten Reben, die ihre Wurzeln durch gebrochenen Granit schlagen konnten, eine ganz andere Option bieten als solche, die auf eher horizontalem Gelände angebaut werden.
                        <br><br>
                        Um dem Trend entgegenzuwirken und die Denkweise der Welt über portugiesischen Spitzenwein zu ändern,
                        Genossenschaften junger Winzer haben den herrlichen Rotwein des Landes wieder aufgegriffen
                        Erbe. Diese vollmundigen Schönheiten sind auf dem Primärmarkt relativ günstig zu erwerben
                        und kann auf dem Sekundärmarkt bis zu xxxx einbringen, daher ist es eine Überlegung wert, wenn Sie möchten
                        Erweitern Sie Ihr Portfolio.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vallée du Douro</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avec autant de variables dans le terroir de la vallée du Douro, on se tromperait en pensant que la différence d'un port à l'autre était une question d'assemblage. Si les caprices du climat et de l'exposition ont toujours été respectés, il a fallu du temps aux Portugais pour comprendre que la preuve était dans le sol. Longtemps considéré comme n'étant que du schiste et du granit, avec la mode émergente du vin de table, les vignerons ont commencé à s'éloigner de la production de Porto et à regarder de plus près ce qu'ils plantaient. En raison des pentes abruptes de la région, les vignes capables de forcer leurs racines à travers le granit cassé pourraient offrir une option très différente de celles qui sont cultivées sur des terrains plus horizontaux.
                        <br><br>
                        Afin d'essayer un dollar la tendance et de changer la pensée du monde sur le bon vin portugais,
                        coopératives de jeunes vignerons revisitent le magnifique vin rouge du pays
                        patrimoine. Ces beautés corsées sont relativement peu coûteuses à acquérir sur le marché primaire
                        et peut rapporter jusqu'à xxxx sur le marché secondaire, il vaut donc la peine d'envisager si vous voulez
                        développez votre folio "port".
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Douro Valley</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        With so many variables in the Douro Valley terroir, one would be mistaken in thinking that the difference in one port to another was about blending. While the vagarities of climate and exposure had always been respected, it took a while for the Portuguese to catch on that the proof was in the soil. Long thought of as being just schist and granite, with the emerging fashion for table wine, winemakers began to step away from Port production and look more closely at what they are planting in. Because of the steep slopes of the region, vines that were able to force their roots through broken granite could offer a very different option than those that are grown on more horizontal terrain.
                        <br><br>
                        In order to try an buck the trend and change the world’s thinking about Portuguese fine wine,
                        cooperatives of young winemakers have been revisiting the country’s magnificent red wine
                        heritage. These full-bodied beauties are relatively inexpensive to acquire on the primary market
                        and can fetch up to xxxx on the secondary market, so it is worth considering if you want to
                        expand your “port” folio.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DouroValley",
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {
                    report: 'Prats and Symington (Chryseia)',
                    src: '/wine-guide/portugal/douro-valley/prats-and-symington'
                },
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {
                    report: 'Roquette & Cazes — Quinta do Crasto',
                    src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
                },
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Douro Valley fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich history and diversity of the Douro Valley wine region, famous for producing some of the world\'s finest Port wines and table wines. Explore the vineyards and taste the exceptional blends crafted by skilled winemakers.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
